// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';

export interface LoggedInUser {
  userId: string;
  userAccessToken: string;

  // Optional fields used by Dapp/Web3 strategies
  primaryParty?: string;
  isConnectedViaDapp?: boolean;
}

export interface UserContextState {
  // State
  loggedInUser: LoggedInUser | undefined;
  isLoading: boolean;

  // Actions
  login: (userId?: string) => Promise<void>;
  logout: () => Promise<void>;

  // Utilities
  isSelfSignedToken: () => boolean;
  signoutOnUnauthorized: (err: unknown) => void;

  // dApp specific
  isConnecting?: boolean;
}

export const UserContext = React.createContext<UserContextState | undefined>(undefined);

export const useUserState = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserState must be used within an AuthFactory strategy');
  }
  return context;
};
